import {Component, EventEmitter, Inject, Input, OnInit, Output, QueryList, ViewChildren} from '@angular/core';
import {Tag} from '../../shared/models/tag.model';
import {MAT_DIALOG_DATA, MatCheckbox, MatCheckboxChange, MatDialogRef, MatSnackBar} from '@angular/material';
import {EditOverviewComponent} from '../../business/edit-overview/edit-overview.component';
import {AirportService} from '../airport.service';
import {TagService} from '../../shared/services/tag.service';
import {Airport} from '../models/airport.model';


@Component({
  selector: 'app-edit-camping',
  templateUrl: './edit-camping.component.html',
  styleUrls: ['./edit-camping.component.scss']
})
export class EditCampingComponent implements OnInit {
  airport: Airport;
  disableClose = false;
  tags: Tag[] = [];
  isLoading = true;
  CampingOnFieldTag: Tag;
  chosenAvailability: string;
  YearRoundTag: Tag;
  SeasonalTag: Tag;
  SpecialEventTag: Tag;
  ReservationsTag: Tag;
  RestroomsTag: Tag;
  ShowersTag: Tag;
  PotableWaterTag: Tag;
  FoodTag: Tag;
  ShelterTag: Tag;
  @Output() change = new EventEmitter<boolean>();
  @Output() error = new EventEmitter<Error>();
  @ViewChildren('checkbox') checkBoxes: QueryList<MatCheckbox>;

  constructor(private _matDialogRef: MatDialogRef<EditOverviewComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _airportService: AirportService,
              private _tagService: TagService,
              private _snackBar: MatSnackBar) {
    this.airport = data.airport;
  }

  async ngOnInit() {
    const allTags = await this._tagService.getAllTags();
    this.CampingOnFieldTag = await this._tagService.findTagByName(allTags, 'Camping On Field');
    this.YearRoundTag = await this._tagService.findTagByName(allTags, 'Camping On Field::Availability::Year-Round');
    this.SeasonalTag = await this._tagService.findTagByName(allTags, 'Camping On Field::Availability::Seasonal');
    this.SpecialEventTag = await this._tagService.findTagByName(allTags, 'Camping On Field::Availability::Special Events Only');
    this.ReservationsTag = await this._tagService.findTagByName(allTags, 'Camping On Field::Availability::Reservation Required');
    this.RestroomsTag = await this._tagService.findTagByName(allTags, 'Camping On Field::Facilities::Restrooms');
    this.ShowersTag = await this._tagService.findTagByName(allTags, 'Camping On Field::Facilities::Showers');
    this.PotableWaterTag = await this._tagService.findTagByName(allTags, 'Camping On Field::Facilities::Potable Water');
    this.FoodTag = await this._tagService.findTagByName(allTags, 'Camping On Field::Facilities::Food/Vending');
    this.ShelterTag = await this._tagService.findTagByName(allTags, 'Camping On Field::Facilities::Shelter');
    this.isLoading = false;
    if (this.isChecked(this.SeasonalTag.tagId)) {
      this.chosenAvailability = 'Seasonal';
    } else if (this.isChecked(this.SpecialEventTag.tagId)) {
      this.chosenAvailability = 'Special Events Only';
    } else {
      this.chosenAvailability = 'Year-Round';
      if (!this.isChecked(this.YearRoundTag.tagId)) {
        await this._tagService.postAirportTag(this.YearRoundTag.tagId, this.airport.airportId);
        this.airport = await this._airportService.getAirport(this.airport.identifier, true);
      }
    }
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close();
    });
  }

  isChecked(tagId: number): boolean {
    const TAGS = this.airport.airportTags;
    for (const tag of TAGS) {
      if (tag.tagId === tagId) {
        return true;
      }
    }
    return false;
  }

  async checkBoxChanged (event: MatCheckboxChange) {
    const TAG_ID = +event.source.id;
    try {
      if (event.source.checked) {
          await this._tagService.postAirportTag(TAG_ID, this.airport.airportId);
        this.change.emit();
      } else {
          await this._tagService.deleteAirportTag(TAG_ID, this.airport.airportId);
        this.change.emit();
      }
      this.airport = await this._airportService.getAirport(this.airport.identifier, true);
    } catch (e) {
      this.error.emit(new Error('API Call Failed'));
    }
  }

  async availabilityChanged () {
    if (this.chosenAvailability === 'Special Events Only') {
      if (this.isChecked(this.YearRoundTag.tagId)) {
        await this._tagService.deleteAirportTag(this.YearRoundTag.tagId, this.airport.airportId);
      }
      if (this.isChecked(this.SeasonalTag.tagId)) {
        await this._tagService.deleteAirportTag(this.SeasonalTag.tagId, this.airport.airportId);
      }
      if (!this.isChecked(this.SpecialEventTag.tagId)) {
        await this._tagService.postAirportTag(this.SpecialEventTag.tagId, this.airport.airportId);
      }
    } else if (this.chosenAvailability === 'Seasonal') {
      if (this.isChecked(this.YearRoundTag.tagId)) {
        await this._tagService.deleteAirportTag(this.YearRoundTag.tagId, this.airport.airportId);
      }
      if (!this.isChecked(this.SeasonalTag.tagId)) {
        await this._tagService.postAirportTag(this.SeasonalTag.tagId, this.airport.airportId);
      }
      if (this.isChecked(this.SpecialEventTag.tagId)) {
        await this._tagService.deleteAirportTag(this.SpecialEventTag.tagId, this.airport.airportId);
      }
    } else {
      // Year-Round (default)
      if (!this.isChecked(this.YearRoundTag.tagId)) {
        await this._tagService.postAirportTag(this.YearRoundTag.tagId, this.airport.airportId);
      }
      if (this.isChecked(this.SeasonalTag.tagId)) {
        await this._tagService.deleteAirportTag(this.SeasonalTag.tagId, this.airport.airportId);
      }
      if (this.isChecked(this.SpecialEventTag.tagId)) {
        await this._tagService.deleteAirportTag(this.SpecialEventTag.tagId, this.airport.airportId);
      }
    }
    this.airport = await this._airportService.getAirport(this.airport.identifier, true);
  }

  async close() {
    if (this.airport) {
      if (!this.isChecked(this.CampingOnFieldTag.tagId)) {
        if (this.isChecked(this.YearRoundTag.tagId)) {
          await this._tagService.deleteAirportTag(this.YearRoundTag.tagId, this.airport.airportId);
        }
        if (this.isChecked(this.SeasonalTag.tagId)) {
          await this._tagService.deleteAirportTag(this.SeasonalTag.tagId, this.airport.airportId);
        }
        if (this.isChecked(this.SpecialEventTag.tagId)) {
          await this._tagService.deleteAirportTag(this.SpecialEventTag.tagId, this.airport.airportId);
        }
        if (this.isChecked(this.ReservationsTag.tagId)) {
          await this._tagService.deleteAirportTag(this.ReservationsTag.tagId, this.airport.airportId);
        }
        if (this.isChecked(this.RestroomsTag.tagId)) {
          await this._tagService.deleteAirportTag(this.RestroomsTag.tagId, this.airport.airportId);
        }
        if (this.isChecked(this.ShowersTag.tagId)) {
          await this._tagService.deleteAirportTag(this.ShowersTag.tagId, this.airport.airportId);
        }
        if (this.isChecked(this.PotableWaterTag.tagId)) {
          await this._tagService.deleteAirportTag(this.PotableWaterTag.tagId, this.airport.airportId);
        }
        if (this.isChecked(this.FoodTag.tagId)) {
          await this._tagService.deleteAirportTag(this.FoodTag.tagId, this.airport.airportId);
        }
        if (this.isChecked(this.ShelterTag.tagId)) {
          await this._tagService.deleteAirportTag(this.ShelterTag.tagId, this.airport.airportId);
        }
        this.airport = await this._airportService.getAirport(this.airport.identifier, true);
      }
      this._matDialogRef.close(true);
    }
  }

  handleError() {
    this._matDialogRef.close(false);
  }
}
